import { BasePageComponent } from '@/components/base/BasePageComponent';
import { AuthenticationService } from '@/services/authentication.service';
import { NavService } from '@/services/nav.service';
import { Component, OnInit } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRole } from '@eemo/api-client';
import { AdminCertificationRequestsComponent } from '../admin-certification-requests/admin-certification-requests.component';
import { AdminCompaniesComponent } from '../admin-companies/admin-companies.component';
import { AdminEventsComponent } from '../admin-events/admin-events.component';
import { AdminOthersComponent } from '../admin-others/admin-others.component';
import { AdminPaymentsComponent } from '../admin-payments/admin-payments.component';
import { AdminPropertiesComponent } from '../admin-properties/admin-properties.component';
import { AdminPropertySalesComponent } from '../admin-property-sales/admin-property-sales.component';
import { AdminSubscriptionsComponent } from '../admin-subscriptions/admin-subscriptions.component';
import { AdminUsersComponent } from '../admin-users/admin-users.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  standalone: true,
  imports: [
    MatTabsModule,
    AdminEventsComponent,
    AdminPropertiesComponent,
    AdminUsersComponent,
    AdminSubscriptionsComponent,
    AdminPaymentsComponent,
    AdminPropertySalesComponent,
    AdminCertificationRequestsComponent,
    AdminCompaniesComponent,
    AdminOthersComponent
  ]
})
export class AdminComponent extends BasePageComponent implements OnInit {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    protected route: ActivatedRoute,
    protected navService: NavService
  ) {
    super(route, navService);
  }

  ngOnInit() {
    if (UserRole.ADMIN !== this.authenticationService.currentUserValue.role) {
      this.router.navigate(['/']);
    }
  }
}
